import React, { useState } from 'react';
import { ThreeDotMenu } from 'components/EpisodeEditorPublish/components/InteractiveQuestion/ThreeDotMenu';
import { useFetchQuestionAndResponses } from 'hooks/useInteractivityQnA';
import { SpotifyLogo } from 'components/svgs/SpotifyLogo';
import { Modal } from '@spotify-internal/anchor-ds';
import { css } from 'emotion';
import { useT } from 'client/i18n/hooks/useT';
import { InteractiveQuestionForm } from '../InteractiveQuestionForm';
import {
  Title,
  RoundedCard,
  CopyContainer,
  OpenModalButton,
  QuestionTitle,
  StatusText,
  Optional,
  TopBarContainer,
} from '../InteractivePoll/styles';

export function InteractiveQuestion({ episodeId }: { episodeId: string }) {
  const { data, status } = useFetchQuestionAndResponses(episodeId);
  const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
  const t = useT();

  if (!data || status === 'loading') return null;

  const { question: { text = '', questionId } = {} } = data;

  const defaultValues = {
    text,
  };

  return (
    <>
      <Title>
        {t(
          'EpisodeEditorPublish.InteractiveQuestion.Title',
          'Q&A',
          'Questions and answers feature title'
        )}
      </Title>{' '}
      <Optional>
        {t(
          'EpisodeEditorPublish.InteractiveQuestion.TitleOnlyOnSpotify',
          '(Only available on Spotify)',
          'Questions and answers feature spotify exclusive'
        )}
      </Optional>
      <RoundedCard>
        <CopyContainer>
          <TopBarContainer>
            <SpotifyLogo width={63} />
            {questionId && (
              <ThreeDotMenu episodeId={episodeId} questionId={questionId} />
            )}
          </TopBarContainer>
          <QuestionTitle>
            {text ||
              t(
                'EpisodeEditorPublish.InteractiveQuestion.QuestionTitle',
                'Engage with listeners directly from your episode with a question',
                'Questions and answers feature title'
              )}
          </QuestionTitle>
          {questionId && (
            <StatusText>
              {t(
                'EpisodeEditorPublish.InteractiveQuestion.QuestionStatusText',
                'Status: Published',
                'Episode question status text'
              )}
            </StatusText>
          )}
        </CopyContainer>
        {!questionId && (
          <>
            <OpenModalButton
              kind="button"
              type="button"
              onClick={() => setIsQuestionModalOpen(!isQuestionModalOpen)}
              color="purple"
            >
              {t(
                'EpisodeEditorPublish.InteractiveQuestion.AddQuestionLabel',
                'Add a question',
                'Add question text'
              )}
            </OpenModalButton>
            {isQuestionModalOpen && (
              <Modal
                isShowing
                isShowingCloseButton
                aria-labelledby="interactive-question-modal-title"
                onClose={() => setIsQuestionModalOpen(false)}
              >
                <Modal.Title id="interactive-question-modal-title">
                  {t(
                    'EpisodeEditorPublish.InteractiveQuestion.AddQuestionLabel',
                    'Add a question',
                    'Add question text'
                  )}
                </Modal.Title>
                <Modal.Body
                  className={css`
                    text-align: left;
                  `}
                >
                  <InteractiveQuestionForm
                    onSuccess={() => setIsQuestionModalOpen(false)}
                    defaultValues={defaultValues}
                    episodeId={episodeId}
                  />
                </Modal.Body>
              </Modal>
            )}
          </>
        )}
      </RoundedCard>
    </>
  );
}
